import { render, staticRenderFns } from "./groupTaskApproval.vue?vue&type=template&id=152b0598&"
import script from "./groupTaskApproval.vue?vue&type=script&lang=js&"
export * from "./groupTaskApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports